import React from 'react';

const TestPage = () => {
    return (
        <div>
            
        </div>
    );
};

export default TestPage;

// import React, { useEffect, useState } from "react";
// import "./test_page.scss";
// import {baseUrl} from "../../../constants/constants";
// import OneEl from "./one_element/one_el";
//
// export interface ITest {
//     id: number;
//     name: string;
//     description: string;
//     source_link: string;
//     image_url: string;
//     create_date: Date;
//     dzen_link: string,
//     tg_link: string,
//     tags: ITags[]
// }
//
// export interface ITags{
//     id: number,
//     name: string,
// }
//
// export interface ImageTitleInterface {
//     id: number;
//     category_name: string;
//     file_url: string;
//     category_id: number;
// }
//
// const News = () => {
//     const [news, setNews] = useState<ITest[]>([]);
//     const [tags, setTags] = useState<ITags[]>([]);
//     const [image, setImage] = useState<ImageTitleInterface[]>([]);
//     const [mobileImage, setMobileImage] = useState<ImageTitleInterface>()
//     const [showAll, setShowAll] = useState(false);
//     const [selectedTag, setSelectedTag] = useState<string | null>(null)
//
//     const mainTags = 2
//
//     useEffect(() => {
//         fetch(`${baseUrl}news?sort_date=true`)
//             .then((res) => res.json())
//             .then((data) => {
//                 setNews(data);
//             })
//             .catch((err) => {
//                 console.log(err);
//             });
//
//         fetch(`${baseUrl}tags`)
//             .then((result) => result.json())
//             .then((tegi) => {
//                 setTags(tegi)
//             })
//             .catch((err) => {
//                 console.log(err)
//             })
//     }, []);
//
//     useEffect(() => {
//         fetch(`${baseUrl}gallery_images?category_id=16`)
//             .then((res) => res.json())
//             .then((data) => {
//                 setImage(data);
//             })
//             .catch((err) => {
//                 console.log(err);
//             });
//
//         fetch(`${baseUrl}gallery_images/90`)
//             .then((res) => res.json())
//             .then((data) => {
//                 setMobileImage(data);
//             })
//             .catch((err) => {
//                 console.log(err);
//             });
//     }, []);
//
//     const handleTagClick = (tagName: string) => {
//         setSelectedTag(selectedTag === tagName ? null : tagName)
//     }
//
//     const filteredNews = selectedTag
//         ? news.filter((item) =>
//             item.tags.some((tag) => tag.name === selectedTag)
//         )
//         : news;
//
//     return (
//         <>
//            <section>
//                 <h1 className="main_title">События недели</h1>
//
//                 {image.map((i) => (
//                     <section className="title-image" key={i.id}>
//                         <img
//                             src={`${baseUrl}${i.file_url}`}
//                             alt="Баннер новостей"
//                             className="title-image__img-news"
//                         />
//                     </section>
//                 ))}
//
//                 {mobileImage &&
//                     <section className={'title-image__mobile'}>
//                         <img
//                             src={`${baseUrl}${mobileImage.file_url}`}
//                             alt="Мобильный баннер новостей"
//                             className={'title-image__img-mobile'}
//                         />
//                     </section>
//                 }
//             </section>
//             <div className="page">
//
//             <section className={'tags'}>
//                 {tags.slice(0, mainTags).map((tags, index) => (
//                     <button
//                         key={index}
//                         className={`tags_button ${selectedTag === tags.name ? "tags_button_active" : ''}`}
//                         onClick={() => handleTagClick(tags.name)}
//                     >
//                         {tags.name}
//                     </button>
//                 ))}
//
//                 <button
//                     className={`tags_button ${showAll ? 'close_button' : ''}`}
//                     onClick={() => setShowAll(!showAll)}
//                 >
//                     {showAll ? "X" : `+${tags.length - mainTags}`}
//                 </button>
//
//                 {showAll &&
//                     tags.slice(mainTags).map((tags, index) => (
//                         <button
//                             className={`tags_button ${selectedTag === tags.name ? 'tags_button_active' : ''}`}
//                             key={index}
//                             onClick={() => handleTagClick(tags.name)}
//                         >
//                             {tags.name}
//                         </button>
//                     ))
//                 }
//
//             </section>
//
//                 {filteredNews && filteredNews.length > 0 ? (
//                     filteredNews.map((item) => <OneEl key={item.id} {...item} />)
//                 ) : (
//                     <h2 className="notFound-title">Новостей пока нет</h2>
//                 )}
//             </div>
//         </>
//     );
// };
//
// export default News;
